var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "dialog-base",
        {
          attrs: {
            visible: _vm.visible,
            title: "Lịch sử thanh toán phiếu thu",
            size: "xl",
            "show-confirm": false,
            "cancel-text": "Đóng",
            "cancel-type": "danger",
            "use-panel": false,
            top: "6vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            cancel: _vm.handleClose,
          },
        },
        [
          _c("div", { staticClass: "sk-panel mb-4" }, [
            _c("div", { staticClass: "sk-panel-head" }, [
              _c(
                "div",
                { staticClass: "sk-panel-icon sk-panel-icon--success" },
                [_c("i", { staticClass: "el-icon-user" })]
              ),
              _c("div", [
                _c("p", { staticClass: "sk-panel-title" }, [
                  _vm._v(_vm._s(_vm.studentName || "Đang tải...")),
                ]),
                _c("p", { staticClass: "sk-panel-subtitle" }, [
                  _vm._v("\n            Mã học sinh: "),
                  _c("strong", [_vm._v(_vm._s(_vm.studentCode || "—"))]),
                  _vm._v(" — \n            Mã phiếu thu: "),
                  _c("strong", [_vm._v(_vm._s(_vm.invoiceCode || "—"))]),
                ]),
              ]),
            ]),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading",
                },
              ],
              staticClass: "sk-table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "empty-text": "Không có lịch sử thanh toán",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "STT",
                  width: "50",
                  align: "center",
                  fixed: "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Ngày tạo", width: "150", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("formatDateTime")(row.createdDate))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Ngày thanh toán",
                  width: "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("formatDate")(row.datePayment))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Người thao tác",
                  width: "150",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(row.nameAction || row.createdBy || "—")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Người thanh toán",
                  width: "150",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [_vm._v(_vm._s(row.parentPay || "—"))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Hình thức", width: "150", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getPaymentMethodTagType(
                                row.paymentMethod
                              ),
                              size: "small",
                              effect: "plain",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.paymentMethodLabel(row.paymentMethod)
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Tiền mặt", align: "right", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "tdi-money" }, [
                          _vm._v(
                            _vm._s(_vm._f("formatCurrency")(row.cashMoney))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Chuyển khoản", align: "right", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "tdi-money" }, [
                          _vm._v(
                            _vm._s(_vm._f("formatCurrency")(row.transferMoney))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Đã thu", align: "right", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          { staticClass: "tdi-money tdi-money--bold" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrency")(row.collectedMoney)
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Chuyển thanh toán",
                  align: "center",
                  width: "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.transactionEntry === "MONEY_WALLET"
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: "warning",
                                  size: "mini",
                                  effect: "light",
                                },
                              },
                              [_vm._v("\n            Không chuyển\n          ")]
                            )
                          : row.transactionEntry === "MONEY_MONTH"
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  effect: "light",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            Sang tháng sau\n          "
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("—")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Mô tả", "min-width": "180", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "description-text" }, [
                          _vm._v(_vm._s(row.noteHistory || "—")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Ảnh bill",
                  width: "100",
                  align: "center",
                  prop: "urlShow",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.urlShow || row.urlPictureOrderSuccess
                          ? _c(
                              "div",
                              [
                                _c("el-image", {
                                  staticClass: "el-image-opacity",
                                  staticStyle: {
                                    width: "35px",
                                    height: "35px",
                                    "border-radius": "4px",
                                    cursor: "pointer",
                                  },
                                  attrs: {
                                    src:
                                      row.urlShow || row.urlPictureOrderSuccess,
                                    fit: "cover",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showPictureHistory(
                                        row.urlShow ||
                                          row.urlPictureOrderSuccess
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _c("span", [_vm._v("—")]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisibleImg,
            width: "35%",
            "append-to-body": "",
            "custom-class": "sk-image-preview-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleImg = $event
            },
          },
        },
        [
          _c("div", { staticClass: "flex justify-center items-center p-2" }, [
            _c("img", {
              staticStyle: {
                "max-width": "100%",
                "max-height": "70vh",
                "border-radius": "8px",
                "box-shadow": "0 4px 12px rgba(0, 0, 0, 0.15)",
              },
              attrs: { src: _vm.urlImgPicture },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }